// extracted by mini-css-extract-plugin
module.exports = {"label":"radio-button_label__2bidY d-inline-flex align-items-center","checkmark":"radio-button_checkmark__2n43o","radio":"radio-button_radio__3ZngP"};